<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 营养门诊-健康行为记录
-->

<template>
  <div class="bodyinfo-page">
    <div class="title">健康自评与症状</div>
    <div class="form-wrapper">
      <van-form @submit="onSubmit" :scroll-to-error="true">
        <div class="form-item" v-for="item in qsList" :key="item.name">
          <template v-if="item.name == 'healthZpJtqzjb'">
            <div class="form-item-label">{{ item.label }}</div>
            <div class="form-item-input">
              <van-field :name="item.name" :rules="[{ required: true, message: '请选择' }]">
                <template #input>
                  <van-radio-group v-model="formData[item.name]" direction="vertical" icon-size="1.33rem">
                    <van-radio class="van-radio__label" v-for="opt in pastMedicalDictChild" :key="opt.id" :name="opt.id"
                      checked-color="#FBB13D">{{ opt.name }}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </div>
          </template>
          <template v-else-if="item.name !== 'healthZpJtqzjb'">
            <div class="form-item-label">{{ item.label }}</div>
            <div class="form-item-input">
              <van-field :name="item.name" :rules="[{ required: true, message: '请选择' }]">
                <template #input>
                  <van-checkbox-group v-if="item.type === 'checkbox'" v-model="formData[item.name]"
                    direction="vertical">
                    <van-checkbox :key="opt.key" v-for="opt in item.options" class="van-radio__label" :name="opt.key" icon-size="16px"
                      checked-color="#FBB13D">{{ opt.label }}</van-checkbox>
                  </van-checkbox-group>
                  <van-radio-group v-else v-model="formData[item.name]" direction="vertical" icon-size="1.33rem">
                    <template v-if="item.name == 'healthZpQzjblb'">
                      <van-radio @click="onChange(opt)" class="van-radio__label" v-for="opt in pastMedicalDict"
                        :key="opt.id" :name="opt.id" checked-color="#FBB13D">{{ opt.name }}</van-radio>
                    </template>
                    <!-- <template v-if="item.name == 'healthZpJtqzjb' && formData.healthZpQzjblb > 0">
                      <van-radio class="van-radio__label" v-for="opt in pastMedicalDictChild" :key="opt.id"
                        :name="opt.id" checked-color="#FBB13D">{{ opt.name }}</van-radio>
                    </template> -->
                    <template v-else>
                      <van-radio class="van-radio__label" v-for="opt in item.options" :key="opt.key" :name="opt.key"
                        checked-color="#FBB13D">{{ opt.label }}</van-radio>
                    </template>

                  </van-radio-group>
                </template>
              </van-field>
            </div>
          </template>
        </div>


        <div class="next-btn-wrapper">
          <van-button round block color="#FBB13D" native-type="button" plain @click="onClickPrev">上一页</van-button>
          <van-button round block color="#FBB13D" type="info" native-type="submit">下一页</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HealthAssess',
  props: {
    pastMedicalDict: Array,
    pastMedicalDictChild: Array,
    initData: {
      type: Object,
      default: () => {}
    },
    baseInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      qsList: [{
        label: '1.整体健康状况？',
        name: 'healthZpZtjkzk',
        options: [{
          label: "良好",
          key: '1'
        }, {
          label: "一般",
          key: '2'
        }, {
          label: "较差",
          key: '3'
        }]
      }, {
        label: '2.常见不适症状（可多选）？',
        name: 'healthZpCjbszzs',
        type: 'checkbox',
        options: [{
          label: "无",
          key: '0'
        },{
          label: "持续疲劳",
          key: '1'
        }, {
          label: "头晕",
          key: '2'
        }, {
          label: "便秘/腹泻",
          key: '3'
        }, {
          label: "腿抽筋",
          key: '4'
        }, {
          label: "牙龈出血",
          key: '5'
        }]
      }, {
      //   label: '3.确诊疾病类别？',
      //   name: 'healthZpQzjblb',

      // }, {
        label: '3.具体确诊疾病？',
        name: 'healthZpJtqzjb',

      }],
      formData: {
        healthZpQzjblb:1
        // healthZpJtqzjb: []
      }
    }
  },
  created() {

  },
  mounted() {
    this.formData = {...this.initData}
    console.log('健康自评与症状', this);
    
    // if(this.formData.healthZpQzjblb){
    //   this.onChange({id:this.formData.healthZpQzjblb})
    // }
  },
  methods: {
    onSubmit(values) {
      let query = { ...values,healthZpQzjblb:1 }
      this.$emit('next-step', { type: 'healthAssess', data: query })
    },
    onClickPrev() {
      this.$emit('prev-step')
    },
    // onChange(e) {
    //   console.log('onChange',this.formData, e);
    //   if(e.id == 1 && this.baseInfo.bmi < 20){
    //     this.$toast(`温馨提示：因您BMI为${this.baseInfo.bmi}，为了身体营养均衡不建议减肥！`);
    //     this.formData.healthZpQzjblb = ''
    //   }else{
    //     this.pastMedicalDictChild = this.pastMedicalDict.filter(item => item.id == e.id)[0].children || []
    //   }
      
    // }
  }
};
</script>

<style scoped>
div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.bodyinfo-page {
  width: 100%;
  height: 100vh;
  padding: 2rem;
  background-color: #fff;
}

.bodyinfo-page .title {
  height: 2.33rem;
  font-weight: 500;
  font-size: 1.67rem;
  color: #333333;
  line-height: 2.33rem;
  margin-bottom: 2rem;
}

.form-wrapper {
  padding-bottom: 5rem;
}

.form-wrapper .form-item {
  margin-bottom: 2rem;
}

.form-wrapper .form-item .form-item-label {
  font-weight: 500;
  font-size: 1.33rem;
  color: #333333;
  line-height: 1.83rem;
  text-align: left;
  margin-bottom: 1rem;
}

.form-wrapper .form-item .form-item-input {
  /* width: 100%;
  height: 3.5rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  background: #F8F9FA; */
}

.icon-mark {
  width: 100px;
  font-size: 1.17rem;
}

.form-wrapper .form-item .form-item-input .van-cell {
  /* background: #F8F9FA; */
  padding-left: 0;
  border-bottom: 1px solid #e8e9ec;
}

.next-btn-wrapper {
  width: 100%;
  height: 6.9rem;
  display: flex;
  gap: 1.42rem;
  background-color: #fff;
  position: fixed;
  z-index: 99;
  bottom: 0;
  left: 0;
  padding: 0.33rem 2rem;
  box-shadow: inset 0rem 0.04rem 0rem 0rem rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
}

.form-wrapper .form-item .van-radio__label,
.bodyinfo-page .van-radio__label {
  font-size: 1.33rem;
  margin-bottom: 1rem;
}
</style>
